export const SellingSystemOptions = [
  { id: 'prodigi', name: 'Prodigi' },
  { id: 'printful', name: 'Printful' },
  { id: 'printify', name: 'Printify' },
  { id: 'gooten', name: 'Gooten' },
  { id: 'cloudprinter', name: 'Cloudprinter' },
  { id: 'moteefe', name: 'Moteefe' },
  { id: 'apliiq', name: 'Apliiq' },
  { id: 'other', name: 'txt_other' },
];
